import * as React from 'react'
import { DatePicker } from 'material-ui-pickers'
import * as moment from 'moment';
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core'
import {WithI18n, withI18n} from '../../core/i18n/withI18n'
import autobind from 'autobind-decorator';

const styles = (t: Theme) => createStyles({});

interface IProps extends WithStyles<typeof styles>, WithI18n {
  input: any;
  meta: any;
  label: string;
}

interface IState {
  date: any;
}

class DateField extends React.Component<IProps, IState> {

  state = {
    date: null
  };

  componentWillMount(){
    if(this.props.input.value){
      this.setState({date: moment(this.props.input.value)});
    }
  }

  componentDidUpdate(prevPros){
    const {input} = this.props;
    if(!!input && !!input.value && moment(input.value).isValid() && input.value !== prevPros.input.value){
      this.setState({date: moment(input.value)});
    }
  }

  render(){
    const {
      t,
      meta: {touched, error}, label,  ...rest
    } = this.props;
    
    return (
      <DatePicker
        keyboard
        label={label}
        format={moment().localeData().longDateFormat("L")}
        placeholder={moment().localeData().longDateFormat("L")}
        value={this.state.date}
        onChange={this.handleChange}
        onInputChange={this.handleRawChange}
        invalidDateMessage="Format de date invalide"
        mask={this.handleMask}
        animateYearScrolling
        okLabel={t.save}
        cancelLabel={t.cancel}
        fullWidth
        {...(error && touched) && {
          error: true,
          helperText: error
        }}
        {...rest}
      />
    )
  }

  @autobind
  private handleChange(d){
    this.setState({date: d});
    this.props.input.onChange(d);
  };

  @autobind
  private handleMask(value){
    return value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : []
  }

  @autobind
  private handleRawChange(e) {
    this.props.input.onBlur();
    this.props.input.onChange(e.target.value);
  }
}

export default withStyles(styles)(withI18n(DateField))



// WEBPACK FOOTER //
// ./src/shared/form/DateField.tsx